import React from 'react';
import { Instagram, Youtube, Twitter } from 'lucide-react';
import { modelInfo, socialLinks } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const getSocialIcon = (platform) => {
    switch (platform) {
      case 'instagram':
        return <Instagram size={20} />;
      case 'youtube':
        return <Youtube size={20} />;
      case 'twitter':
        return <Twitter size={20} />;
      case 'tiktok':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-bebas text-3xl tracking-[0.2em] mb-4">
              {modelInfo.name.toUpperCase()}
            </h3>
            <p className="font-poppins text-sm text-gray-400 leading-relaxed">
              {modelInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-poppins text-xs tracking-[0.3em] text-gray-400 mb-6">
              QUICK LINKS
            </h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Portfolio', 'Videos', 'Contact'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase()}`}
                    className="font-poppins text-sm text-gray-300 hover:text-white transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-poppins text-xs tracking-[0.3em] text-gray-400 mb-6">
              FOLLOW
            </h4>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.platform}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-gray-700 flex items-center justify-center text-gray-400 hover:text-white hover:border-white transition-all duration-300"
                  aria-label={social.platform}
                >
                  {getSocialIcon(social.platform)}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-poppins text-xs text-gray-500">
              © {currentYear} {modelInfo.name}. All rights reserved.
            </p>
            <p className="font-poppins text-xs text-gray-500">
              Designed with passion
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
